export class BikeStatusColor {
    static readonly GREEN = '#5CA909';
    static readonly AMBER = '#F5A623';
    static readonly RED = '#B60707';
    static readonly GRAY = '#949499';
    static readonly BLACK = '#000000';
    static readonly BLUE = '#1690D6';
    static readonly PURPLE = '#6236BA';
    static readonly PINK = '#E75480';
    static readonly ORANGE = '#FF8200';
}